// index.html 의 정적 SEO 태그와 ogRender 가 크롤러용으로 주입한 태그(data-static)는 JS 를 안 돌리는 크롤러용 폴백이다.
// React 19 는 페이지의 title·meta·link 를 <head> 에 '추가'만 하고 정적 태그를
// 지우지 않아 title·description·og·twitter 가 두 벌이 된다(SEO 감사 2026-10).
// → 페이지가 같은 키의 태그를 내놓으면 정적 것을 떼고, 그 페이지가 사라지면 되돌린다.

// og:image:width 등 하위 속성은 부모(og:image)를 페이지가 내놓으면 같이 뗀다.
const keyOf = (el) =>
  el.tagName === "TITLE"
    ? "title"
    : el.tagName === "LINK"
    ? "canonical"
    : (el.getAttribute("property") || el.getAttribute("name") || "").replace(
        /^(og:image|twitter:image):.*$/,
        "$1"
      );

export function syncStaticHead(head, statics) {
  const live = new Set(
    [...head.querySelectorAll("title, meta, link[rel=canonical]")]
      .filter((el) => !el.hasAttribute("data-static"))
      .map(keyOf)
  );
  for (const el of statics) {
    if (live.has(keyOf(el))) el.remove();
    else if (!el.isConnected) head.prepend(el);
  }
}

export function watchStaticHead(head = document.head) {
  const statics = [...head.querySelectorAll("[data-static]")];
  const sync = () => syncStaticHead(head, statics);
  // 자기 remove/prepend 로도 다시 불리지만 두 번째 호출은 변화가 없어 멈춘다.
  new MutationObserver(sync).observe(head, { childList: true });
  sync();
}
